export const toCurrency = value => {
  const regexp = new RegExp(/^[0-9]*(\.[0-9]{1,2})*$/g)
  if(regexp.test(value)) return value
  else return ''
}


// WEBPACK FOOTER //
// ./src/utils/toCurrency.js